import { action } from '@ember/object';
import { service } from '@ember/service';
import { isPresent } from '@ember/utils';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { isNothing } from 'donor-elf-web/lib/object-utils';
import ContactModel from 'donor-elf-web/models/contact';
import ContactsCache from 'donor-elf-web/services/contacts-cache';
import CurrentUser from 'donor-elf-web/services/current-user';

interface ComponentArgs {
  contact: ContactModel;
}

export default class ContactPropertiesComponent extends Component<ComponentArgs> {
  @service declare contactsCache: ContactsCache;
  @service declare currentUser: CurrentUser;

  @tracked showAddProperty = false;

  get showAddPropertyHelpMessage() {
    return (
      (this.contactsCache.customProperties.length <= 1 &&
        this.hiddenCustomPropertyInfos.length === 0) ||
      this.currentUser.isDemoUser
    );
  }

  get sortedCustomPropertyInfos() {
    return this.contactsCache.sortedCustomPropertiesForDetailPage;
  }

  get showHiddenProperties() {
    return (
      this.contactsCache.showHiddenCustomPropertiesOnDetailPage &&
      this.hiddenCustomPropertyInfos.length > 0
    );
  }

  get alwaysShowCustomPropertyInfos() {
    let { customPropertyUserSettingForDetailPage } = this.contactsCache;
    return this.sortedCustomPropertyInfos.filter(
      (p) => customPropertyUserSettingForDetailPage[p.l]?.show === true,
    );
  }

  get hideIfBlankCustomPropertyInfos() {
    let { customPropertyUserSettingForDetailPage } = this.contactsCache;
    return this.sortedCustomPropertyInfos.filter(
      (p) =>
        customPropertyUserSettingForDetailPage[p.l]?.show !== true &&
        customPropertyUserSettingForDetailPage[p.l]?.hide !== true,
    );
  }

  get alwaysHideCustomPropertyInfos() {
    let { customPropertyUserSettingForDetailPage } = this.contactsCache;
    return this.sortedCustomPropertyInfos.filter(
      (p) => customPropertyUserSettingForDetailPage[p.l]?.hide === true,
    );
  }

  get visibleCustomPropertyInfos() {
    let propertyInfos = [...this.alwaysShowCustomPropertyInfos];
    for (let info of this.hideIfBlankCustomPropertyInfos) {
      if (isPresent(this.args.contact.customPropertiesByLabel[info.l]?.v)) {
        propertyInfos.push(info);
      }
    }
    return propertyInfos;
  }

  get hiddenCustomPropertyInfos() {
    let propertyInfos = [];
    for (let info of this.hideIfBlankCustomPropertyInfos) {
      if (isNothing(this.args.contact.customPropertiesByLabel[info.l]?.v)) {
        propertyInfos.push(info);
      }
    }

    return [...propertyInfos, ...this.alwaysHideCustomPropertyInfos];
  }

  @action
  toggleShowAddProperty(val: boolean) {
    this.showAddProperty = val;
  }

  @action
  toggleShowHiddenProperties(val: boolean) {
    this.contactsCache.showHiddenCustomPropertiesOnDetailPage = val;
  }
}
